<template>
<v-container fluid>
 <v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="6000"
  absolute
  >
  {{ message }}
  <v-btn
    dark
    text
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
</v-snackbar>
<v-layout class="mt-12">
<v-flex xs12>
  <div :class="paginatedItems.length === 5 ? 'approvesettlements_box' : 'approvesettlements_box_empty'">
    <v-card-title>
      <v-flex xs5>
        <span class="accent--text" style="font-size: 14px; font-weight:700;"> Approved Loan Requests </span>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs1>
      <v-btn small color="secondary" @click="getReport"> Export </v-btn>
      </v-flex>
    </v-card-title>
    <v-card-text>
    <!-- <table class="table">
      <thead class="thead">
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Member No</th>
          <th scope="col">First Name</th>
          <th scope="col">Last Name</th>
          <th scope="col">Mobile No</th>
          <th scope="col">Organisaction Name</th>
          <th scope="col">Date Created</th>
          <th scope="col">Amount</th>
          <th scope="col">Approval Date </th>
          <th scope="col">Status</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in paginatedItems" v-bind:key="item.id">
          <td> {{ item.id }} </td>
          <td> {{ item.farmer.memberNumber }} </td>
          <td> {{ item.farmer.firstName }}</td>
          <td> {{ item.farmer.lastName }}</td>
          <td> {{ item.farmer.mobileNumber }}</td>
          <td> {{ item.farmer.organisation.organisationName }}</td>
          <td>{{ item.dateCreated | formatDate }}</td>
          <td>{{ item.amount }}</td>
          <td> {{ item.disburseApprovalDecisionDate | formatDate }} </td>
          <td>{{ getApprovedStatus(item) }}</td>
          <td class="actions">
            <v-btn @click="getLoanRequestDetails1(item,'approve')"> View </v-btn>
          </td>
        </tr>
      </tbody>
    </table> -->
    <v-data-table
      :headers="headers"
      :items="results"
      class="elevation-1"
      :search="search"
      disable-pagination
      :hide-default-footer="true"
    >
    <template v-slot:[`header.farmer.farmerId`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.farmer.fullName`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.farmer.mobileNumber`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.grower.organisationName`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.dateCreated`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.amount`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.disburseApprovalDecisionDate`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.disburseStatus`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`item.dateCreated`]="{ item }">
       {{item.dateCreated  }}
    </template>
    <template v-slot:[`item.disburseApprovalDecisionDate`]="{ item }">
       {{item.disburseApprovalDecisionDate | formatDate }}
    </template>
    <template v-slot:[`item.disburseStatus`]="{ item }">
       {{ getApprovedStatus(item) }}
    </template>
    <template v-slot:[`item.actions`]="{ item }">
       <v-btn color="primary" @click="getLoanRequestDetails1(item,'approve')"> View </v-btn>
    </template>
    </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-col cols="12" sm="9">
          <v-pagination
            v-model="page"
            :length="totalPages"
            total-visible="7"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
            @input="handlePageChange"
          ></v-pagination>
      </v-col>
    </v-card-actions>
  </div>
</v-flex>
<v-dialog v-model="approveDialog" persistent>
  <v-card>
    <v-card-title class="title accent--text text-capitalize">
      Approved Loan Request
    </v-card-title>
    <v-card-text>
       <table class="table">
        <thead class="thead">
          <tr>
          <th scope="col">National Id</th>
          <th scope="col">First Name</th>
          <th scope="col">Last Name</th>
          <th scope="col">Mobile No</th>
          <th scope="col">Organisaction Name</th>
          <th scope="col">Organisaction Code</th>
          <th scope="col">Date Created</th>
          <th scope="col">Amount</th>
          <th scope="col">Status</th>
          <th scope="col">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in loan" v-bind:key="item.farmer.memberNumber">
          <td> {{ item.farmer.farmerId }} </td>
          <td>{{ item.farmer.firstName }}</td>
          <td>{{ item.farmer.lastName }}</td>
          <td>{{ item.farmer.mobileNumber }}</td>
          <td>{{ item.grower.organisationName }}</td>
          <td>{{ item.grower.organisationCode }}</td>
          <td>{{ item.dateCreated  }}</td>
          <td>{{ item.amount }}</td>
          <td>{{ item.disburseStatus.statusName }}</td>
          <td>{{ item.narration }}</td>
          </tr>
          <tr>
          <td colspan="8"><strong>Comment</strong></td>
          </tr>
          <tr v-for="item in loan" v-bind:key="item.id">
          <!-- <td colspan="8">{{ item.approvalComment }}</td> -->
          <td colspan="8">{{ item.narration }}</td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" flat @click="closeApproveDialog"> Close </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<v-dialog v-model="declineDialog" max-width="900" persistent>
  <v-card>
    <v-card-title class="title accent--text text-capitalize">
      Decline Loan Request
    </v-card-title>
    <v-card-text>
       <table class="table">
        <thead class="thead">
          <tr>
          <th scope="col">National Id</th>
          <th scope="col">First Name</th>
          <th scope="col">Last Name</th>
          <th scope="col">Mobile No</th>
          <th scope="col">Organisaction Name</th>
          <th scope="col">Organisaction Code</th>
          <th scope="col">Date Created</th>
          <th scope="col">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in loan" v-bind:key="item.farmer.memberNumber">
          <td>{{ item.farmer.farmerId }} </td>
          <td>{{ item.farmer.firstName }}</td>
          <td>{{ item.farmer.lastName }}</td>
          <td>{{ item.farmer.mobileNumber }}</td>
          <td>{{ item.grower.organisationName }}</td>
          <td>{{ item.grower.organisationCode }}</td>
          <td>{{ item.dateCreated | prettyDate }}</td>
          <td>{{ item.amount }}</td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" flat @click="closeDeclineDialog"> Close </v-btn>
      <v-spacer> </v-spacer>
      <v-btn color="secondary" round @click="declineLoanRequest"> Decline </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'

export default {
	name: 'approvesettlements',
	data: function () {
		return {
			message: '',
			snackbar: false,
			snackbarColor: '',
			loading: false,
			search: '',
			permissions: [],
			results: [],
			totalResults: 0,
			paginatedItems: [],
			paginatedSettlements: [],
			numberOfLinks: 0,
			sNumberOfLinks: 0,
			numberOfItemsPerPage: 10,
			page: 1,
			sPage: 1,
			approveDialog: false,
			settlementdetails: [],
			payment: {},
			loan: [],
			declineDialog: false,
			organisationId: '',
			headers: [
				{ text: 'National Id', value: 'farmer.farmerId' },
				{ text: 'Name', value: 'farmer.fullName' },
				{ text: 'Mobile No', value: 'farmer.mobileNumber' },
				{ text: 'Org Name', value: 'grower.organisationName' },
				{ text: 'Date Created', value: 'dateCreated' },
				{ text: 'Amount', value: 'amount' },
				// { text: 'Approval Date', value: 'disburseApprovalDecisionDate' },
				{ text: 'Status', value: 'disburseStatus' },
				{ text: 'Actions', value: 'actions', sortable: false }
			],
			totalPages: 0,
			pageSize: 6
		}
	},
	mounted () {
		this.getLoggedInUser()
		this.loadData()
	},
	watch: {
	},
	computed: {
	},
	methods: {
		getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
			this.organisationType = this.theUser.organisation.organisationType.name
			this.organisationId = this.theUser.organisation.id
			// this.curUserN = this.curUser.firstName
		},
		closeApproveDialog () {
			this.approveDialog = false
			this.settlementdetails = []
		},
		closeDeclineDialog () {
			this.declineDialog = false
			this.settlementdetails = []
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		getApprovedStatus (item) {
			if (item) {
				if (item.disburseStatus) {
					return item.disburseStatus.description.replace('_', ' ')
				}
			}
		},
		loadData () {
			const params = this.getRequestParams(
				this.search,
				this.page,
				this.pageSize

			)
			const url = config.serverURI + '/disbursement/approved/' + this.organisationId
			axios.get(url, { params })
				.then(response => {
					const { data, page } = response.data
					this.results = data
					this.totalPages = page.totalPages
				})
				.catch(error => {
					console.log('error', error.response)
				})
			return this.results
		},
		getReceivedPayments () {
			const url = config.serverURI + '/payment/unapprovedpayments'
			axios.get(url)
				.then(response => {
					this.results = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
			return this.results
		},
		getLoanRequestDetails1 (item, requestType) {
			console.log('test', item)
			console.log('requestType', requestType)
			if (item.disbursementTransaction == null) {
				item.disbursementTransaction = {
					disbursementStatus: '',
					disbursementDescription: ''
				}
			}
			if (item.approvalComment == null) {
				item.approvalComment = ''
			}
			this.loan = [item]
			if (requestType === 'approve') {
				this.approveDialog = true
			} else {
				this.declineDialog = true
			}
		},
		getLoanRequestDetails (item, requestType) {
			const url = config.serverURI + '/settlement/transactions'
			axios.post(url, item)
				.then(response => {
					this.settlementdetails = response.data
					this.payment = item
					if (requestType === 'approve') {
						this.approveDialog = true
					} else {
						this.declineDialog = true
					}
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		approveSettlement () {
			const url = config.serverURI + '/disbursement/approve'
			this.payment.settlementTransactions = this.settlementdetails
			console.log(this.payment)
			axios.post(url, this.payment)
				.then(response => {
					this.snackbar = true
					this.snackbarColor = 'success'
					this.message = response.data.message
					this.getReceivedPayments()
					this.closeApproveDialog()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		approveLoanRequest () {
			const url = config.serverURI + '/disbursement/approve'
			console.log(this.loan)
			axios.post(url, this.loan)
				.then(response => {
					this.snackbar = true
					this.snackbarColor = 'success'
					this.message = response.data.message
					this.loadData()
					this.closeApproveDialog()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		declineLoanRequest () {
			const url = config.serverURI + '/disbursement/reject'
			axios.post(url, this.loan[0])
				.then(response => {
					this.snackbar = true
					this.snackbarColor = 'success'
					this.message = response.data.message
					this.loadData()
					this.closeDeclineDialog()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		getReport () {
			const url = config.serverURI + '/disbursement/download/'+this.organisationId
			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = 'loantransactions.csv'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		getRequestParams (name, page, pageSize) {
			const params = {}
			if (page) {
				params.page = page - 1
			}
			if (pageSize) {
				params.size = pageSize
			}
			if (name) {
				params.name = name
			}

			params.paginate = 'Y'
			return params
		},
		handlePageChange (value) {
			this.page = value
			this.loadData()
		},
		handlePageSizeChange (size) {
			this.pageSize = size
			this.page = 1
			this.loadData()
		}
	}
}

</script>
<style scoped>
.mytable .v-table tbody tr:not(:last-child) {
    border-bottom: none;
}
.approvesettlements_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.approvesettlements_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.approvesettlements_box:after, .approvesettlements_box:before {
  right: 100%;
  top: 80%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.approvesettlements_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.approvesettlements_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.table  tbody  tr >  td.actions {
  font-size: 10px !important;
  color: #733D29 !important;
  text-align:center;
  vertical-align: middle;
  padding-top: 0px;
  height: 10px;
}

</style>
